import { motion } from 'framer-motion'
import { ArrowRight, HandMetal } from 'lucide-react'
import type { ReactNode } from 'react'
import { Row } from 'src/shared/components/Semantic/all'
import { Button } from 'src/shared/components/ui/button'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const PingKlayderTeamCta = ({
  isPending,
  onPing,
  locked,
  actionHint,
}: {
  isPending?: boolean
  onPing: () => void
  locked?: boolean
  actionHint?: ReactNode
}) => {
  const { t } = useLocalization()

  if (locked) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        className="mx-3 mb-2 mt-2 rounded-xl border border-amber-200/60 bg-amber-50/50 px-3 py-2"
      >
        <Row className="items-center gap-3">
          <p className="min-w-0 flex-1 text-xs font-medium leading-snug text-amber-950">
            {t(
              'To continue the conversation and complete the purchase, please sign up.',
              'För att fortsätta konversationen och slutföra köpet, skapa ett konto.'
            )}
          </p>
          <Button
            variant="primaryOrange"
            size="sm"
            className="heartbeat-border-3 h-7 shrink-0 px-2.5 text-xs"
            onClick={onPing}
          >
            {t('Sign up for free', 'Registrera dig gratis')}
            <ArrowRight className="ml-1 h-3 w-3" />
          </Button>
        </Row>
      </motion.div>
    )
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      className="mx-3 mb-2 mt-2 rounded-xl border border-amber-200/60 bg-amber-50/50 px-3.5 py-3"
    >
      <Row className="items-center gap-3">
        <span className="text-xl" aria-hidden>
          👋
        </span>
        <p className="min-w-0 flex-1 text-xs font-medium text-amber-950">
          {t('Ready for us to read this?', 'Redo att vi läser det här?')}
        </p>
        <Row className="shrink-0 items-center gap-2">
          {actionHint}
          <Button
            variant="primary"
            size="sm"
            className="heartbeat-border-3 shrink-0"
            disabled={isPending}
            onClick={onPing}
          >
            <HandMetal className="mr-1.5 h-3.5 w-3.5" />
            {t('Ping Klayder team', 'Pinga Klayder-teamet')}
          </Button>
        </Row>
      </Row>
    </motion.div>
  )
}
